import HelpQuestion from "./HelpQuestion";
import type { HelpQuestionAdapterProps } from "./HelpQuestion.d";

export { HelpQuestion };
export type { HelpQuestionAdapterProps };
